import { Upload, Calculator, FileCheck, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/contexts/LanguageContext";

export function HowItWorksSection() {
  const { t } = useLanguage();

  const steps = [
    {
      icon: Upload,
      stepKey: "how_it_works.step1.number",
      titleKey: "how_it_works.step1.title",
      descriptionKey: "how_it_works.step1.description",
    },
    {
      icon: Calculator,
      stepKey: "how_it_works.step2.number",
      titleKey: "how_it_works.step2.title",
      descriptionKey: "how_it_works.step2.description",
    },
    {
      icon: FileCheck,
      stepKey: "how_it_works.step3.number",
      titleKey: "how_it_works.step3.title",
      descriptionKey: "how_it_works.step3.description",
    },
  ];

  return (
    <section className="py-24 bg-muted/30" aria-labelledby="how-it-works-heading">
      <div className="container mx-auto px-4">
        {/* Header */}
        <header className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block text-secondary font-semibold text-sm uppercase tracking-wider mb-4">
            {t("how_it_works.badge")}
          </span>
          <h2 id="how-it-works-heading" className="font-display font-bold text-3xl md:text-4xl lg:text-5xl text-foreground mb-6">
            {t("how_it_works.title")}
          </h2>
          <p className="text-lg text-muted-foreground">
            {t("how_it_works.subtitle")}
          </p>
        </header>

        {/* Steps */}
        <div className="grid md:grid-cols-3 gap-8 lg:gap-12 mb-12">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              {/* Connector Line */}
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-16 left-1/2 w-full h-0.5 bg-gradient-to-r from-secondary/50 to-secondary/10" />
              )}

              <div className="relative bg-card rounded-3xl border border-border p-8 text-center hover:shadow-xl transition-shadow">
                {/* Step Number */}
                <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-secondary text-secondary-foreground font-display font-bold text-sm px-4 py-1 rounded-full">
                  Krok {t(step.stepKey)}
                </div>

                {/* Icon */}
                <div className="w-20 h-20 mx-auto bg-gradient-to-br from-primary/10 to-secondary/10 rounded-2xl flex items-center justify-center mb-6 mt-4">
                  <step.icon className="w-10 h-10 text-secondary" />
                </div>

                {/* Content */}
                <h3 className="font-display font-bold text-xl text-foreground mb-3">
                  {t(step.titleKey)}
                </h3>
                <p className="text-muted-foreground leading-relaxed">
                  {t(step.descriptionKey)}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center">
          <Link to="/kalkulator">
            <Button size="lg" className="bg-gradient-to-r from-secondary to-primary hover:opacity-90 text-primary-foreground font-bold px-8 py-6 text-lg rounded-xl shadow-xl">
              {t("how_it_works.cta")}
              <ArrowRight className="w-5 h-5 ml-2" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
}
